
import { Component, Vue, Watch } from 'vue-property-decorator';
import { namespace } from "vuex-class";

import "@/store/modules/forms/manualForm";
const manualFormState = namespace("ManualForm");

import "@/store/modules/common";
const commonState = namespace("Common");

import StepNumber from "@/components/utils/StepNumber.vue";
import GetHelpForPdf from "./components/GetHelpForPDF.vue";
import UploadDocumentHeader from "./components/UploadDocumentHeader.vue";
import Spinner from "@/components/utils/Spinner.vue";

import { manualFormSearchInfoType, partiesFormInfoType, partiesStateInfoType } from '@/types/Information/ManualForm';
import { partiesDataJsonDataType } from '@/types/Information/json';
import { documentTypesJsonInfoType } from '@/types/Common';
import PartiesTable from './PartiesTable.vue';

@Component({
    components:{
        StepNumber,
        GetHelpForPdf,        
        UploadDocumentHeader,
        Spinner,
        PartiesTable            
    }
})
export default class ChecklistOrders extends Vue { 

    @manualFormState.State
    public currentManualFormsId!: string;

    @commonState.State
    public documentTypesJson: documentTypesJsonInfoType[]

    supportingDocuments = []; 
	    
    inactiveButtonClass = "bg-secondary text-white"; 
    activeButtonClass = "bg-success text-white"; 

    yesNoOptions = [
        {text: 'Yes', value: true},
        {text: 'No', value: false}
    ];

    responseOptions = [
        {text: 'New', value: true},
        {text: 'Existing', value: false}
    ];

    respondentOptions = [
        {text: 'Individual', value: 'Individual'},
        {text: 'Organization', value: 'Organization'}
    ];
    
    levelOfCourt = "Court of Appeal";

    fileNumberState = true;
    respondentState = true;

    dataReady = false;
    searching = false;
    resultsReady = false;
    stepStyle = "font-size: 2rem;";
    searchParams = {} as manualFormSearchInfoType;
    notFound = false;

    appellantNames = '';
    respondentNames = '';
    formInfo = {} as partiesFormInfoType;
    states = {appellants:null, respondents:null, interveners: null} as partiesStateInfoType;
    newApplication = null;    
    rejectionResponse = null;
    waiveFees = null;

    displayRejectionQuestion = false;
    displayWaiveFeesQuestion = false;    
    displayFileSearch = false;
    displayApplicationSubmission = false;
    displayParties = false;
    partyState=null

    update = 0;
    partyUpdated = 0;

    error = "";
    showGetHelpForPDF = false;

    submitting = false;
        
    supportingFile = null;
    selectedDocumentTypeState = true;
    selectedSupportingDocumentState = true;
    fileType = "";    

    supportingDocumentFields = [
        { key: 'fileName', label: 'File Name',tdClass:'align-middle'},
        { key: 'fileType', label: 'File Type',tdClass:'align-middle'},
        { key: 'edit', thClass: 'd-none',tdClass:'align-middle'},
        { key: 'preview', thClass: 'd-none'}
    ];
       
    showTypeOfDocuments = false;
    submitEnable = true;

    @Watch('displayApplicationSubmission')
    public addDropListeners(){ 
        if(this.displayApplicationSubmission == true) 
            Vue.nextTick(()=>{      
                const dropArea = document.getElementById('drop-area');
                dropArea.addEventListener('drop', this.handleFileDrop, false);
                dropArea.addEventListener('dragenter', this.dragPreventDefaults, false);
                dropArea.addEventListener('dragleave', this.dragPreventDefaults, false);
                dropArea.addEventListener('dragover', this.dragPreventDefaults, false);
            })             
    }
    
    mounted(){
        this.dataReady = false;  
        this.fileNumberState = true;
        this.respondentState = true;
        this.resultsReady = false;
        this.newApplication = null;       
        this.rejectionResponse = null;
        this.waiveFees = null;  
        this.formInfo.appellants = []
        this.formInfo.respondents =[]
        this.formInfo.interveners =[]
        this.submitting = false;
        this.partyState=null
        this.error = "";     
        this.appellantNames = "";
        this.respondentNames = "";
        this.resetValues();
        this.searching = false;
        this.dataReady = true; 
    }

    public extractInfo(parties: partiesDataJsonDataType){
        this.formInfo.appellants = parties.appellants? parties.appellants: [];
        this.formInfo.respondents = parties.respondents? parties.respondents: [];
        this.displayApplicationSubmission = true; 
        const appellants = parties.appellants.map(resp=>resp.name)
        const respondents = parties.respondents.map(resp=>resp.name)
        this.appellantNames = appellants.join(', ');
        this.respondentNames = respondents.join(', ');        
    }

    public findFile(){

        this.searching = true;        
        this.notFound = false;
        this.fileNumberState = true;
        this.respondentState = true;
        this.displayApplicationSubmission = false;
        this.appellantNames = "";
        this.respondentNames = "";
        this.formInfo.appellants = []
        this.formInfo.respondents =[]
        this.formInfo.interveners =[]

        if(!this.searchParams.file){
            this.fileNumberState = false;
            this.searching = false;
            return
        }

        if(!this.searchParams.searchBy){
            this.respondentState = false;
            this.searching = false;
            return
        }
        
        const url = '/form7s/?'+
            'caseNumber='+(this.searchParams.file?this.searchParams.file:'')+
            '&firstName='+(this.searchParams.firstName?this.searchParams.firstName:'')+
            '&lastName='+(this.searchParams.lastName?this.searchParams.lastName:'')+
            '&searchBy='+(this.searchParams.searchBy?this.searchParams.searchBy:'')+
            '&organizationName='+(this.searchParams.organizationName?this.searchParams.organizationName:''); 
        
        this.resultsReady = true;
        
        this.$http.get(url)
        .then(res => {            

            if (res.data){

                if(res.data?.parties){
                    this.extractInfo(res.data.parties)                                   
                }
                
                this.notFound = false;

            } else {
                this.notFound = true;
            }
            this.searching = false;
            Vue.filter('scrollInto')('results-table')
                
        },err => {
            console.error(err); 
            this.notFound = true;  
            this.searching = false;     
        });
    }

    public resetValues(){
        this.displayRejectionQuestion = false;
        this.displayWaiveFeesQuestion = false;  
        this.displayFileSearch = false;
        this.displayApplicationSubmission = false;
        this.error = "";
        this.searchParams = {} as manualFormSearchInfoType
        this.resultsReady = false;
        this.notFound = false;
        this.displayParties = false;
        this.partyState=null;
    }

    public updateNewApplication(){
        this.resetValues();                
        this.displayRejectionQuestion = this.newApplication != null;
        this.displayWaiveFeesQuestion = this.rejectionResponse != null;
        this.determineSubmissionQualification() 
        this.update++;
    }

    public updateRejectionQuestion(){
        this.resetValues();
        this.displayRejectionQuestion = true;       
        this.displayWaiveFeesQuestion = this.rejectionResponse != null;
        this.determineSubmissionQualification()        
        this.update++;
    }

    public updateWaiveFeesQuestion(){
        this.resetValues();
        this.displayRejectionQuestion = true;
        this.displayWaiveFeesQuestion = true;  
        this.determineSubmissionQualification()
        this.update++;
    } 

    public determineSubmissionQualification(){

        if (this.newApplication != null && this.rejectionResponse == false && this.waiveFees == false){
            this.displayFileSearch = !this.newApplication;
            Vue.nextTick(()=>this.displayApplicationSubmission = this.newApplication);
            this.displayParties = this.newApplication;
            Vue.filter('scrollInto')('scroll-into-point') 
        } else {
            this.displayFileSearch = false;
            this.displayApplicationSubmission = false;
            this.displayParties = false;
        }
    }

    public submit() {
        
        this.error =""
        const bodyFormData = new FormData();
        const docType = []

        const lastFileTypes = this.supportingDocuments[this.supportingDocuments.length-1]?this.supportingDocuments[this.supportingDocuments.length-1].typeIndex:[]
        if (!this.supportingDocuments?.length){
            this.error = 'Please upload your supporting documents'
            return
        }
        
        if(this.newApplication && !lastFileTypes.includes('NAA')){
            this.error = 'Please add the "Notice of Appeal - Court of Appeal" document as well.'
            return
        }

        if(this.formInfo.appellants.length==0 && this.formInfo.respondents.length==0 && this.formInfo.interveners.length==0){
            this.partyState=false
            Vue.filter('scrollInto')('is-invalid')
            return
        }
                        

        let fileIndex = 0;
        for(const filetype of lastFileTypes){
        
            const tempSupportingDocs = this.supportingDocuments?.filter(doc=>{return(doc.documentType==filetype)})
            const filetypeName = this.documentTypesJson.filter(doc => doc.type==filetype)

            if(tempSupportingDocs.length>0){
                const filesIndices = [];
                const filesRotation = [];
                for(const supportingDoc of tempSupportingDocs){
                    bodyFormData.append('files',supportingDoc['file']);
                    filesIndices.push(fileIndex)
                    filesRotation.push(supportingDoc['imageRotation'])
                    fileIndex++;
                }
                docType.push(
                    {
                        type: tempSupportingDocs[0]['documentType'],
                        typeName: filetypeName.length>0 ? filetypeName[0].description: '',  
                        fileName: tempSupportingDocs.map(doc => doc['fileName']),
                        files: filesIndices, 
                        rotations:filesRotation
                    })
            }
        }
        
        const docTypeJson = JSON.stringify(docType);
        bodyFormData.append('documents', docTypeJson); 

        const body = {
            data:{  
                appellants: this.formInfo.appellants,
                respondents: this.formInfo.respondents,
                interveners:this.formInfo.interveners,
                doc_type: docType,
                formSevenNumber: this.searchParams?.file? this.searchParams.file : null               
            },
            description:"Manual Submission",
            type:"ManualSubmission"
        }
        bodyFormData.append('body', JSON.stringify(body));

        this.submitting = true;
        const url = "/manual-submissions/efiling/new/submit/";
        const header = {
            responseType: "json",
            headers: {
                "Content-Type": "multipart/form-data",
                Accept: "application/json"                  
            }
        }
        
        this.$http.post(url, bodyFormData, header)
        .then(res => {
            
            if(res.data?.message=="success" && res.data?.redirectUrl){
                const eFilingUrl = res.data?.redirectUrl
                location.replace(eFilingUrl);
                //this.submitting = false;
            }else
                this.submitting = false;
            
        }, err => {
            console.log(err.response?.data?.message);
            const generalError = " Error in submission. Please refresh the page and try again."
            if(err.response?.data?.message)
                this.error = err.response.data.message
            else if(err.response?.data?.detail)
                this.error = err.response.data.detail+generalError
            else
                this.error = generalError
            this.submitting = false;
        });        

    }



    public dragPreventDefaults (e) {
        e.preventDefault()
        e.stopPropagation()
    }

    public handleFileDrop(e) {
        e.preventDefault()
        e.stopPropagation()
        const dt = e.dataTransfer
        const files = dt.files

        if (files && files[0]) 
        {
            this.supportingFile = files;            
            this.showTypeOfDocuments= true;
        }
    } 

    public uploadClicked(){
        const el = document.getElementById("inputfile");
        if(el) el.click();
    }

    public handleSelectedFile(event){

        event.preventDefault();
        event.stopPropagation();
        
        if (event.target.files && event.target.files[0]) 
        {
            this.supportingFile = event.target.files;
            this.showTypeOfDocuments= true;
        }
    }

    public addDocument() {
        this.selectedDocumentTypeState = this.fileType.length>0? true: false;

        if (this.supportingFile && this.fileType.length>0) {

            this.showTypeOfDocuments = false;

            const supportingdocuments = this.supportingDocuments 
            let typeIndex =  this.supportingDocuments[this.supportingDocuments.length-1]?this.supportingDocuments[this.supportingDocuments.length-1].typeIndex:[]
            if(!typeIndex.includes(this.fileType))
                typeIndex.push(this.fileType)
            
            for(const supportingfile of this.supportingFile){
            
                const newFile = {
                    "fileName": supportingfile.name,
                    "file": supportingfile,
                    "documentType": this.fileType,
                    "image": URL.createObjectURL(supportingfile),
                    "imageRotation": 0,
                    "typeIndex":typeIndex
                }
                supportingdocuments.push(newFile);
            }

            this.error = "";
            this.supportingFile = null;
            this.fileType = "";
            Vue.nextTick(()=>{
                const el = document.getElementById('drop-area');
                if(el) el.scrollIntoView();
            })
        }
    }

    public removeDocument(index) {
        this.supportingDocuments.splice(index, 1);
    }
  

}
